import $ from 'jquery';
import CookieService from "./CookieService";

const COOKIE_NAME_LEVELS = 'bz_cookie_levels';
const COOKIE_NAME_ACTION_TAKEN = 'bz_cookie_levels_action_taken';
const COOKIE_EXPIRE = 60 * 60 * 24 * 365 * 5;
const SELECT_LEVEL_SELECTOR = '[data-cookie-consent-select-level]';
const LEVEL_BUTTON_SELECTOR = 'button' + SELECT_LEVEL_SELECTOR;
const LEVEL_CHECKBOXES_SELECTOR = '[type="checkbox"]' + SELECT_LEVEL_SELECTOR;
const LEVELS_DATA_ATTRIBUTE = 'levels';
const COOKIE_LEVEL_EVENT_PREFIX = 'cle-';
const COOKIE_SUBMIT_MESSAGE_VISIBLE_MODIFIER = 'cookie-consent-settings__form__submit-message--visible';
const COOKIE_SUBMIT_MESSAGE_VISIBLE_OPACITY_MODIFIER = 'cookie-consent-settings__form__submit-message--visible-opacity';
const HIDDEN_CHECKBOX_CLASS = 'hidden-checkbox';

export default class CookieConsent {

    static get COOKIE_LEVEL_EVENT_PREFIX() {
        return COOKIE_LEVEL_EVENT_PREFIX;
    }

    constructor() {
        this.$selectLevelButtons = $(LEVEL_BUTTON_SELECTOR);
        this.$selectLevelCheckboxes = $(LEVEL_CHECKBOXES_SELECTOR);
        this.cookieService = new CookieService();
        this.$cookieDisclaimer = $('.cookie-disclaimer');
        this.$cookieConsentSettingsForm = $('#cookie-consent-settings__form');
        this.$cookieConsentMessage = $('.cookie-consent-settings__form__submit-message');
        this.bindEvents();
        this.syncCookiesWithCheckboxes();
    }

    handleCookieActionTaken() {
        this.$cookieDisclaimer.hide();
        this.cookieService.setCookie(COOKIE_NAME_ACTION_TAKEN, COOKIE_EXPIRE, true);
        this.$cookieConsentMessage.addClass(COOKIE_SUBMIT_MESSAGE_VISIBLE_MODIFIER)

        setTimeout(function () {
            this.$cookieConsentMessage.addClass(COOKIE_SUBMIT_MESSAGE_VISIBLE_OPACITY_MODIFIER);
        }.bind(this), 5);

        setTimeout(function () {
            this.$cookieConsentMessage.removeClass(COOKIE_SUBMIT_MESSAGE_VISIBLE_MODIFIER);
            this.$cookieConsentMessage.removeClass(COOKIE_SUBMIT_MESSAGE_VISIBLE_OPACITY_MODIFIER);
        }.bind(this), 5000);

        this.triggerLevelEvents();
    }

    bindEvents() {
        $(window).on('load', function () {
            this.triggerLevelEvents();
        }.bind(this));

        this.$cookieConsentSettingsForm.on('submit', function (e) {
            e.preventDefault();
            this.storeSelectedLevels(
                this.$cookieConsentSettingsForm.serializeArray()
            );
        }.bind(this));

        if (this.$selectLevelButtons.length > 0) {
            this.$selectLevelButtons.on('click', this.buttonLevelSelect.bind(this));

        }

        if (this.$selectLevelCheckboxes.length > 0) {
            this.$selectLevelCheckboxes.on('change', this.checkboxLevelSelect.bind(this));
        }
    }

    triggerLevelEvents() {
        let consentedLevels = this.cookieService.getCookieValue(COOKIE_NAME_LEVELS);
        if (consentedLevels) {
            consentedLevels = JSON.parse(consentedLevels);

            consentedLevels.forEach(function (level) {
                $(document).trigger(COOKIE_LEVEL_EVENT_PREFIX + level.toString(), [level.toString()]);
            });
        }
    }

    buttonLevelSelect(e) {
        let $element = $(e.target);
        let levels = $element.data(LEVELS_DATA_ATTRIBUTE);

        levels.forEach(function (level) {
            this.addLevelToCookie(level);
        }.bind(this));

        this.syncCookiesWithCheckboxes();
    }

    checkboxLevelSelect(e) {
        let $checkbox = $(e.target);
        this.syncChildLevels($checkbox);
    }

    storeSelectedLevels(serializedForm) {
        let selectedLevels = [];
        serializedForm.forEach(function (input) {
            let $checkbox = $('[name="' + input.name + '"]')
            if ($checkbox.length > 0) {
                selectedLevels.push(input.name);
            }
        }.bind(this));

        this.setLevelsToCookie(selectedLevels);
    }

    syncCookiesWithCheckboxes() {
        let consentedLevels = this.getLevelsCookieValue();

        if (consentedLevels) {
            // Sync checkboxes with chosen level cookies
            $('.' + HIDDEN_CHECKBOX_CLASS).remove();
            $(LEVEL_CHECKBOXES_SELECTOR).each(function () {
                $(this).prop('checked', false);
                $(this).prop('disabled', false);
            });

            consentedLevels.forEach(function (level) {
                $('[type="checkbox"][name="' + level + '"]').prop('checked', true);
            });

            $(LEVEL_CHECKBOXES_SELECTOR + ':checked').each(function (i, checkbox) {
                this.syncChildLevels($(checkbox));
            }.bind(this));
        }
    }

    syncChildLevels($checkbox) {
        let levels = $checkbox.data(LEVELS_DATA_ATTRIBUTE);
        let isChecked = $checkbox.is(':checked');

        levels.forEach(function (level) {
            let $childLevelCheckbox = $('[type="checkbox"][name="' + level + '"]');
            if (!$childLevelCheckbox.is($checkbox)) {
                $childLevelCheckbox.prop('checked', isChecked)
                $childLevelCheckbox.prop('disabled', isChecked);
                if (isChecked) {
                    this.$cookieConsentSettingsForm.append('<input class="' + HIDDEN_CHECKBOX_CLASS + '" value="on" type="hidden" name="' + level + '">');
                } else {
                    $('.' + HIDDEN_CHECKBOX_CLASS + '[name="' + level + '"]').remove();
                }
            }
        }.bind(this));
    }

    addLevelToCookie(level) {
        let consentedLevels = this.getLevelsCookieValue();
        consentedLevels.push(level);
        consentedLevels = consentedLevels.filter(this.onlyUnique);
        this.cookieService.deleteCookie(COOKIE_NAME_LEVELS);
        this.cookieService.setCookie(COOKIE_NAME_LEVELS, COOKIE_EXPIRE, JSON.stringify(consentedLevels));
        this.handleCookieActionTaken();
    }

    setLevelsToCookie(levels) {
        let consentedLevels = levels.filter(this.onlyUnique);
        this.cookieService.deleteCookie(COOKIE_NAME_LEVELS);
        this.cookieService.setCookie(COOKIE_NAME_LEVELS, COOKIE_EXPIRE, JSON.stringify(consentedLevels));
        this.handleCookieActionTaken();
    }

    getLevelsCookieValue() {
        let consentedLevels = this.cookieService.getCookieValue(COOKIE_NAME_LEVELS);

        if (!consentedLevels) {
            consentedLevels = [];
        } else {
            consentedLevels = JSON.parse(consentedLevels);
        }

        return consentedLevels;
    }

    onlyUnique(value, index, self) {
        return self.indexOf(value) === index;
    }
}



// WEBPACK FOOTER //
// ./www/wp-content/themes/accelerator/src/Accelerator/Components/Modules/CookieConsent/resources/scripts/front/CookieConsent/CookieConsent.js